import {UserAgentService} from "../services/UserAgentService";
import {ConfigService, DistributionMode} from "../services/ConfigService";
import {Request} from "./Router";
import { isChromeHeadless, isCrawler } from "./crawler";

const userAgentService = UserAgentService.getInstance() as UserAgentService;
const config = ConfigService.getInstance() as ConfigService;

function refreshCookieTimeout(params: Object) {
	// Expiry of 2 mins
	Cookies.set("cdp-parameters", JSON.stringify(params), {expires: config.CDP_COOKIE_EXPIRY});
	if ((<any>window).CDPCookieInterval) {
		clearInterval((<any>window).CDPCookieInterval);
	}
	// Update cookie every minute to update expiry of cookie to 2 mins.
	(<any>window).CDPCookieInterval = setInterval(() => {
		Cookies.set("cdp-parameters", JSON.stringify(params), {expires: config.CDP_COOKIE_EXPIRY});
	}, config.CDP_COOKIE_REFRESH);
}

export function setupCDPSimple(isNativeReq: boolean, req?: Request) {
	// If in distribution experience, do not use cookies else use cookies if available
	if (isCrawler()) {
		Cookies.remove("cdp-parameters");
		return;
	}
	if (isNativeReq) {
		if (req.params["traffic_source"]) {
			// CDP mode
			if (req.params["traffic_source"] === "destination_simple") {
				config.DISTRIBUTION_MODE = DistributionMode.SIMPLE;
			} else {
				config.DISTRIBUTION_MODE = DistributionMode.INLINE;
			}

			if (!userAgentService.mobile && req.params["publisher_name"] && req.params["website_url"]) {
				config.CDP_SIMPLE_HEADER = true;
				config.CDP_PUBLISHER_NAME = req.params["publisher_name"].replace(/__/g, " ");
				config.CDP_BACK_LINK = req.params["website_url"];
			}

			let postalCode = req.params["fsa"] || req.params["postal_code"];
			if (postalCode) {
				document.documentElement.setAttribute("postalcode", postalCode);
				document.documentElement.setAttribute("city", "");
			}
			// Create cookie incase they refresh or nav away
			refreshCookieTimeout({
				"publisher_name": req.params["publisher_name"],
				"website_url": req.params["website_url"],
				"fsa": postalCode,
				"channel_id": req.params["channel_id"],
				"locale": req.params["locale"],
				"traffic_source": req.params["traffic_source"]
			});
		} else {
			// Module mode
			config.DISTRIBUTION_MODE = DistributionMode.MODULE;
		}
		return false;
	} else {
		// FW mode
		const CDPCookie = Cookies.get("cdp-parameters");
		if (CDPCookie) {
			const data = JSON.parse(CDPCookie);
			// If there is a CDPCookie, force CDP mode
			if (data["traffic_source"] === "destination_simple") {
				config.DISTRIBUTION_MODE = DistributionMode.SIMPLE;
			} else {
				config.DISTRIBUTION_MODE = DistributionMode.INLINE;
			}

			if (data["publisher_name"] && data["website_url"]) {
				config.CDP_SIMPLE_HEADER = true;
				config.CDP_PUBLISHER_NAME = data["publisher_name"].replace(/__/g, " ");
				config.CDP_BACK_LINK = data["website_url"];
			}

			// For the following fields, add/replace their value in req.params
			const trimmedData = ["locale", "fsa", "channel_id", "traffic_source"].reduce((acc, field) => {
				if (data.hasOwnProperty(field)) acc[field] = data[field];
				return acc;
			}, <{ [key: string]: string }>{});
			if (!isChromeHeadless()) {
				req.params = {...req.params, ...trimmedData};
			} else {
				Cookies.remove("cdp-parameters");
			}

			if (data["fsa"]) {
				document.documentElement.setAttribute("postalcode", data["fsa"]);
				document.documentElement.setAttribute("city", "");
			}
			refreshCookieTimeout(data);

			config.FORCE_NATIVE = true;
			return true;
		}
		return false;
	}
}
